export const getAvatarImageFromName = (name: string) => {
  const avatarImages = {
    'Adrian Guery': '/static/users/adrian.webp',
    'Amélie Bonnet': '/static/users/amelie.webp',
    'Myriam Hinderer': '/static/users/myriam.webp',
  };

  return avatarImages[name];
};

export const getUserJobFromName = (name: string) => {
  const userJobs = {
    'Adrian Guery': 'AutoCut Engineer',
    'Amélie Bonnet': 'Marketing Manager',
    'Myriam Hinderer': 'Marketing Manager',
  };

  return userJobs[name];
};
